import React, { useEffect } from "react";
import { List } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import EditIcon from "@material-ui/icons/Edit";
import { withRouter } from "react-router";
import { get } from "../../api/axios";
const NegociosList = props => {
  const [negocios, setNegocios] = React.useState([]);
  useEffect(() => {
    get("/negocios").then(response => {
      let negocios = response.data.sort(function (a, b) {
        if (a.nombre < b.nombre) { return -1; }
        if (a.nombre > b.nombre) { return 1; }
        return 0;
      });
      setNegocios(negocios);
    });
  }, []);

  return (
    <List
      component="nav"
      aria-label="main mailbox folders"
      style={{ maxHeight: "400px", overflow: "auto" }}
    >
      {negocios.map((negocio, key) => {
        return (
          <ListItem
            button
            onClick={() => props.history.push("/negocios/editar/" + negocio.id)}
            key={key}
          >
            <ListItemText primary={negocio.nombre} />
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
          </ListItem>
        );
      })}
    </List>
  );
};

export default withRouter(NegociosList);
